import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAdmin } from "../../utils/backend";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ViewAdmin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [admin, setAdmin] = useState({});
  const { id } = useParams();

  const hasPermission = (permissionGroup, permissionName) => {
    let permissions;
    try {
      permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      permissions = [];
    }

    return permissions.some(
      (perm) =>
        perm.permission_group === permissionGroup &&
        perm.permission_name === permissionName
    );
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const response = await getAdmin({ id: id });
      setAdmin(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAdmin({});
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
      navigate("/admins");
  };

  return (
    <>
      {/* <h5 className='mb-3'>Admin Details</h5> */}
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton
                height={40}
                width={100}
                style={{ marginRight: "10px" }}
              />
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">ID</label>
                <p>
                  <b>{admin.id}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Username</label>
                <p>
                  <b>{admin.username}</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Role</label>
                <p>
                  <b>{admin.role}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Email</label>
                <p>
                  <b>{admin.email}</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Phone Number</label>
                <p>
                  <b>{admin.phone_number}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Full Name</label>
                <p>
                  <b>{admin.full_name}</b>
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn me-3 ansa-button-secondary"
                onClick={handleBackClick}
              >
                Back
              </button>
              {hasPermission("Admin Management", "Edit") && (
                <button
                  type="button"
                  className="btn ansa-button-primary"
                  onClick={() => navigate(`/admins/details/${id}/edit`)}
                  disabled={admin.username === "superadmin"}
                >
                  Edit
                </button>
              )}{" "}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewAdmin;
